/** @flow */

import type { DataSecurityState } from "./types";

export const initialState: DataSecurityState = {
  requestsInProgress: 0,
  securitySettings: null,
  schema: null,
};

export default initialState;
